import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { BatchApiAdapter } from '../adapters/BatchApiAdapter';

const httpClient = createHttpClient(apiClientWH);
const adapter = new BatchApiAdapter(httpClient);

export const useBatchStatusCounts = () => {
  return useQuery({
    queryKey: ['batches', 'status-summary'],
    queryFn: () => adapter.getStatusSummary(),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};
